export const formatAmount = (amount) =>
    new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
}).format(Number(amount) || 0);

export const getFlagUrl = (countryCode) => {
    if (!countryCode) return "";
    return `https://flagcdn.com/w20/${countryCode.toLowerCase()}.png`;
};

export const getCurrencyInfoByCurrencyCode = (currencyOptions, code) => {
    return currencyOptions?.find(c => c.currencyCode === code) || {};
};

export const getCurrencyInfoByCountryCode = (currencyOptions, code) => {
    return currencyOptions?.find(c => c.countryCode === code) || {};
};